/**
 * @deprecated - This theme will be deleted in a future release of RJSF once we upgrade to React 19
 */
import SemanticUIForm from './SemanticUIForm/SemanticUIForm';

export { default as Templates, generateTemplates } from './Templates';
export { default as Form, generateForm } from './SemanticUIForm';
export { default as Theme, generateTheme } from './Theme';
export { default as Widgets, generateWidgets } from './Widgets';

export default SemanticUIForm;
